export const environment = {
	  production: true,
	  company: 'server_nieuw',
	SocketIO_EndPoint: 'https://mcg.backend.jbmsoftware.nl',
	RecipeAppSupport: true,
	  APIUrl: 'https://mcg.backend.jbmsoftware.nl/'
};
